import request from '../utils/request'
import baseUrl from './baseUrl'

export const sendFile = (data) => request({
  url: baseUrl + '/upload/fileUpload',
  method: 'POST',
  data
})